
const Feature = ({image,alt}) => {
  return (
    <div className="mx-auto px-4 relative top-16 md:top-28">
    <img className='w-full  max-h-[600px] mx-auto object-cover' 
    src={image} alt={alt}></img>
    </div>
  )
}

export default Feature